/* eslint-disable no-restricted-syntax */
import { fork } from 'redux-saga/effects';

// auth
import authRootSaga from './auth/root-saga';

// board
import { watcher as reqAllUsers } from './board/reqAllUsers';
import { watcher as reqRelatedUsers } from './board/reqRelatedUsers';
import { watcher as reqNewChannel } from './board/reqNewChannel';
import { watcher as reqSocialChannel } from './board/reqSocialChannel';
import { watcher as reqAssignPatient } from './board/reqAssignPatient';
import { watcher as reqAssignProvider } from './board/reqAssignProvider';
import { watcher as reqCircleOfCare } from './board/reqCircleOfCare';
import { watcher as reqRelationshipPriority } from './board/reqRelationshipPriority';
import { watcher as reqFilters } from './board/reqFilters';
import { watcher as reqInvitePatient } from './board/reqInvitePatient';
import { watcher as reqChangeChatName } from './board/reqChangeChatName';
import { watcher as reqMetadata } from './board/reqMetadata';
import { watcher as reqChannels } from './board/reqChannels';
import { watcher as reqChannelParticipants } from './board/reqChannelParticipants';
import { watcher as reqAddParticipants } from './board/reqAddParticipants';
import { watcher as reqRemoveParticipant } from './board/reqRemoveParticipant';
import { watcher as reqChannel } from './board/reqChannel';
import { watcher as reqBlockUser } from './board/reqBlockUser';
import { watcher as reqUnblockUser } from './board/reqUnblockUser';
import { watcher as createChatInboxTask } from './board/create-chat-inbox-task-req';
import { watcher as blockUserForDependent } from './board/block-user-for-dependent';
import { watcher as unblockUserForDependent } from './board/unblock-user-for-dependent';
import { watcher as dependentChannelParticipants } from './board/dependent-channel-participants';
import boardSagas from './board/sagas';

// chat connection
import chatConnectionSagas from './chatConnection/sagas';
import downloadAttachmentSaga from './chatConnection/sagas/downloadAttachment';
import uploadAttachmentSaga from './chatConnection/sagas/uploadAttachment';
import { watcher as sendMessageSaga } from './chatConnection/sendMessage';

// common
import { watcher as urlPreview } from './common/urlPreview';
import { watcher as appState } from './data/app-state-req';
// circles
// TODO use circles root saga
import { watcher as caregiver } from './circles/caregiver';
import { watcher as memberFamilyCircle } from './circles/memberFamilyCircle';
import { watcher as myFamilyCircle } from './circles/myFamilyCircle';
import { watcher as inviteToFamilyCircle } from './circles/inviteToFamilyCircle';
import { watcher as leaveFamilyCircle } from './circles/leaveFamilyCircle';
import { watcher as acceptInviteToFamilyCircle } from './circles/acceptInviteToFamilyCircle';
import { watcher as declineInviteToFamilyCircle } from './circles/declineInviteToFamilyCircle';
import { watcher as inviteCaregiver } from './circles/inviteCaregiver';
import { watcher as inviteCaregiverFamily } from './circles/inviteCaregiverFamily';
import { watcher as removeCaregiver } from './circles/removeCaregiver';
import { watcher as acceptCaregiverRole } from './circles/acceptCaregiverRole';
import { watcher as declineCaregiverRole } from './circles/declineCaregiverRole';
import { watcher as guardianCircle } from './circles/get-guardian-circle';
import { watcher as removeAssignedProvider } from './circles/removeAssignedProvider';
import { watcher as inviteGuardian } from './circles/invite-guardian';
import { watcher as removeGuardianRole } from './circles/remove-guardian-role';
import { watcher as acceptGuardianRole } from './circles/accept-guardian-role';
import { watcher as declineGuardianRole } from './circles/decline-guardian-role';
import { watcher as cancelFamilyMemberInvitation } from './circles/cancelFamilyMemberInvitation';
import { watcher as cancelCaregiverInvitation } from './circles/cancelCaregiverInvitation';
import { watcher as cancelGuardianInvitation } from './circles/cancel-guardian-invitation-req';
import circlesSagas from './circles/circlesSaga';
import circlesRootSaga from './circles/root-saga';
// context
import {
  addLoggedUserSaga,
  updateLoggedUserSaga,
  createLoggedUserSaga,
  fetchLoggedUserSaga,
  changeLoggedUserDataSaga,
} from './context/loggedUserSagas';
import {
  updateTargetUserSaga,
  fetchTargetUserSaga,
  setTargetUserSaga,
} from './context/targetUserSagas';
import {
  updateCaregiverCirclesSaga,
  updateLoggedUserIdSaga,
  updateTargetUserIdSaga,
  updateDependentsListSaga,
} from './context/permissionsSaga';
import { addTeamUserSaga } from './context/team-user-saga';
// data constants
import { watcher as constants } from './data/constants';
import { watcher as privacyPolicies } from './data/privacyPolicies';
// invitations
import { watcher as caregiverInvitations } from './invitations/caregiver';
import { watcher as familyMemberInvitations } from './invitations/familyMember';
import { watcher as guardianInvitations } from './invitations/guardian';
import { watcher as declineProgramInvitation } from './programs/declineInvitation';
import { watcher as acceptProgramInvitation } from './programs/acceptInvitation';
// profiles
import { sagas as profileSagas } from './profiles/saga';
// programs: TURN IT OFF until we have program invites
import { watcher as joinedPrograms } from './programs/joinedPrograms';
import { watcher as leaveProgram } from './programs/leaveProgram';
import { watcher as accountVaults } from './programs/accountVaults';
import { watcher as accountVaultsForms } from './programs/accountVaultsForm';
import { watcher as submitPaymentProgram } from './programs/submitPaymentProgram';
import { watcher as availablePrograms } from './programs/availablePrograms';
import { watcher as assignPrograms } from './programs/assignPrograms';
import { programSagas } from './programs/programSagas';

// surveys
import {
  watcher as answeredSurveys,
  paginatedWatcher as paginatedAnsweredSurveys,
} from './surveys/answered';
import { watcher as surveySubmit } from './surveys/submit';
import {
  watcher as upcomingSurveys,
  paginatedWatcher as paginatedUpcomingSurveys,
} from './surveys/upcoming';
import { watcher as surveyForms } from './surveys/forms';
import { watcher as sendSurvey } from './surveys/sendSurvey';
import { watcher as exportSurveyToPDF } from './surveys/exportToPDF';
import { watcher as submitReferralForm } from './surveys/submitReferralForm';
import { watcher as reqReferralForms } from './surveys/reqReferralForms';
import { watcher as reqFormResult } from './surveys/reqFormResult';
import { watcher as upcomingSurvey } from './surveys/upcoming-survey';
import { watcher as upcomingSurveyProceed } from './surveys/upcoming-survey-proceed';
import { watcher as upcomingSurveyAnswers } from './surveys/upcoming-survey-answers';
import { watcher as upcomingSurveyCompletions } from './surveys/upcoming-survey-completions';
import { watcher as upcomingSurveyCancelFilling } from './surveys/upcoming-survey-cancel-filling';
import { watcher as appointmentConsent } from './surveys/appointment-consent-req';
import { getIncomingSurveysSaga } from './surveys/getIncomingSurveysSaga';
import { submitReferralFormSaga } from './surveys/submitReferralFormSaga';
import surveysSagas from './surveys/sagas';

// communities
import {
  watcher as userCommunities,
  paginatedWatcher as paginatedUserCommunities,
} from './communities/userCommunities';
import { watcher as currentCommunityInfo } from './communities/currentCommunityInfo';
import { watcher as communityPreview } from './communities/communityPreview';
import { watcher as communityPostsPreview } from './communities/communityPostsPreview';
import {
  watcher as reqDiscoverCommunities,
  paginatedWatcher as reqPaginatedDiscoverCommunities,
} from './communities/reqDiscoverCommunities';
import {
  watcher as deletePost,
  deletedPostSaga,
} from './communities/deletePost';
import { watcher as communityPosts } from './communities/communityPosts';
import { watcher as communityMembers } from './communities/communityMembers';
import { getMembersListSaga } from './communities/membersListSaga';
import { watcher as communityModerators } from './communities/communityModerators';
import { getModeratorsListSaga } from './communities/moderatorsListSaga';
import { watcher as postDetails } from './communities/postDetails';
import { watcher as createPost } from './communities/createPost';
import { watcher as editPost, editedPostSaga } from './communities/editPost';
import { watcher as leaveCommunity } from './communities/leaveCommunity';
import { watcher as removeUserCommunity } from './communities/removeUserCommunity';
import {
  watcher as editComment,
  editedCommentSaga,
} from './communities/editComment';
import {
  postDetailsSaga,
  postCommentsSaga,
} from './communities/postDetailsSaga';
import { currentCommunitySaga } from './communities/currentCommunitySaga';
import { createdPostSaga, getPostsSaga } from './communities/postsListSagas';
import { getPostsPreviewSaga } from './communities/postsPreviewListSagas';
import {
  watcher as postComment,
  postCommentSaga,
} from './communities/postComment';
import {
  watcher as deleteComment,
  deletedCommentSaga,
} from './communities/deleteComment';
import { watcher as commentsListFetch } from './communities/commentsListFetch';
import { watcher as likePost, postLikedSaga } from './communities/likePost';
import {
  watcher as dislikePost,
  postDislikedSaga,
} from './communities/dislikePost';
import { watcher as reqJoinCommunity } from './communities/reqJoinCommunity';
import { watcher as getUserProfile } from './communities/getUserProfile';
import {
  watcher as communitiesJoinRequests,
  paginatedWatcher as communitiesPaginatedJoinRequests,
} from './communities/communitiesJoinRequests';
import { watcher as acceptJoinRequest } from './communities/acceptJoinRequest';
import { watcher as declineJoinRequest } from './communities/declineJoinRequest';
import { watcher as reqMemberInvitation } from './communities/reqMemberInvitation';
import { getCommentsSaga } from './communities/commentsListSagas';
import communitiesSagas from './communities/sagas';
import { watcher as notificationCounters } from './communities/notificationCounters';
import { watcher as removeNotificationsCounters } from './communities/removeNotificationsCounters';
import {
  watcher as usersJoinRequests,
  paginatedWatcher as usersPaginatedJoinRequests,
} from './communities/usersJoinRequests';
import { watcher as communityImageUpdate } from './communities/communityImageUpdate';
import { watcher as communityImageRemove } from './communities/communityImageRemove';
import { watcher as communityInfoUpdate } from './communities/communityInfoUpdate';
import { watcher as invitationUserSearch } from './communities/invitationUserSearch';
import { watcher as invitationUserToCommunity } from './communities/invitationUserToCommunity';
import { watcher as acceptInvitationToCommunity } from './communities/acceptInvitation';
import { watcher as declineInvitationToCommunity } from './communities/declineInvitation';

import dependentFormRootSaga from './dependentForm/root-saga';
// ui
import { updateSuccessMsgSaga } from './ui/success';
import { updateErrorMsgSaga } from './ui/error';
import locationsSaga from './common/locationsSaga';
import { watcher as complaints } from './complaints/reqSendReport';

import complaintsRootSaga from './complaints/sagas';

// teams
import teamsRootSaga from './teams/root-saga';
import dependentManagementRootSaga from './dependentManagement/root-saga';

import { dashboardSaga } from './dashboard/root-saga';
import healthboardRootSaga from './healthboard/root-saga';
import appointmentFormRootSaga from './appointmentForm/root-saga';
import dataRootSaga from './data/root-saga';
import scheduleRootSaga from './schedule/root-saga';
import { watcher as appointmentsWatcher } from './appointmnents/appointment-details-req';

// consents
import { watcher as acceptProgramConsent } from './programs/acceptConsent';

// paperwork
import paperworkRootSaga from './paperwork/sagas';

// manage insurances
import manageInsurancesRootSaga from './manage-insurances/sagas';

// appointments
import appointmentsRootSaga from './appointmnents/root-saga';
// payment-methods
import paymentMethodsRootSaga from './payment-methods/root-saga';
// guarantor-information
import guarantorsInformationRootSaga from './guarantor-information/root-saga';

const watchers = [
  authRootSaga,
  removeUserCommunity,
  leaveCommunity,
  caregiver,
  memberFamilyCircle,
  myFamilyCircle,
  inviteToFamilyCircle,
  leaveFamilyCircle,
  acceptInviteToFamilyCircle,
  declineInviteToFamilyCircle,
  guardianCircle,
  inviteGuardian,
  removeGuardianRole,
  acceptGuardianRole,
  declineGuardianRole,
  addLoggedUserSaga,
  addTeamUserSaga,
  fetchLoggedUserSaga,
  updateLoggedUserSaga,
  changeLoggedUserDataSaga,
  createLoggedUserSaga,
  updateTargetUserSaga,
  fetchTargetUserSaga,
  setTargetUserSaga,
  updateCaregiverCirclesSaga,
  updateDependentsListSaga,
  updateLoggedUserIdSaga,
  updateTargetUserIdSaga,
  constants,
  privacyPolicies,
  caregiverInvitations,
  familyMemberInvitations,
  guardianInvitations,
  acceptProgramConsent,
  acceptProgramInvitation,
  declineProgramInvitation,
  profileSagas,
  joinedPrograms,
  answeredSurveys,
  paginatedAnsweredSurveys,
  surveySubmit,
  upcomingSurveys,
  paginatedUpcomingSurveys,
  upcomingSurvey,
  upcomingSurveyProceed,
  upcomingSurveyAnswers,
  upcomingSurveyCompletions,
  upcomingSurveyCancelFilling,
  appointmentConsent,
  surveysSagas,
  sendSurvey,
  surveyForms,
  exportSurveyToPDF,
  submitReferralForm,
  reqReferralForms,
  reqFormResult,
  getIncomingSurveysSaga,
  submitReferralFormSaga,
  inviteCaregiver,
  inviteCaregiverFamily,
  removeCaregiver,
  acceptCaregiverRole,
  declineCaregiverRole,
  cancelFamilyMemberInvitation,
  cancelCaregiverInvitation,
  cancelGuardianInvitation,
  circlesSagas,
  circlesRootSaga,
  communitiesSagas,
  userCommunities,
  paginatedUserCommunities,
  reqDiscoverCommunities,
  reqPaginatedDiscoverCommunities,
  currentCommunityInfo,
  communityPreview,
  communityPostsPreview,
  communityPosts,
  postDetails,
  createPost,
  editPost,
  editedPostSaga,
  deletePost,
  deletedPostSaga,
  createdPostSaga,
  getPostsPreviewSaga,
  getPostsSaga,
  postDetailsSaga,
  postComment,
  postCommentSaga,
  commentsListFetch,
  getCommentsSaga,
  currentCommunitySaga,
  urlPreview,
  appState,
  likePost,
  postLikedSaga,
  dislikePost,
  postDislikedSaga,
  deleteComment,
  deletedCommentSaga,
  editComment,
  editedCommentSaga,
  postCommentsSaga,
  reqJoinCommunity,
  communitiesJoinRequests,
  communitiesPaginatedJoinRequests,
  acceptJoinRequest,
  declineJoinRequest,
  notificationCounters,
  usersJoinRequests,
  usersPaginatedJoinRequests,
  removeNotificationsCounters,
  communityImageUpdate,
  communityImageRemove,
  communityInfoUpdate,
  invitationUserSearch,
  invitationUserToCommunity,
  acceptInvitationToCommunity,
  declineInvitationToCommunity,
  reqMemberInvitation,
  getUserProfile,
  reqRemoveParticipant,
  programSagas,
  assignPrograms,
  availablePrograms,
  leaveProgram,
  reqChangeChatName,
  reqAssignPatient,
  reqSocialChannel,
  reqNewChannel,
  reqRelatedUsers,
  reqAllUsers,
  reqCircleOfCare,
  reqFilters,
  reqInvitePatient,
  reqMetadata,
  reqChannels,
  reqChannel,
  reqChannelParticipants,
  dependentChannelParticipants,
  reqAddParticipants,
  boardSagas,
  chatConnectionSagas,
  downloadAttachmentSaga,
  uploadAttachmentSaga,
  sendMessageSaga,
  reqBlockUser,
  reqUnblockUser,
  blockUserForDependent,
  unblockUserForDependent,
  createChatInboxTask,
  locationsSaga,
  updateErrorMsgSaga,
  updateSuccessMsgSaga,
  getMembersListSaga,
  communityMembers,
  getModeratorsListSaga,
  complaints,
  communityModerators,
  complaintsRootSaga,
  dependentFormRootSaga,
  dependentManagementRootSaga,
  teamsRootSaga,
  dashboardSaga,
  dataRootSaga,
  healthboardRootSaga,
  appointmentFormRootSaga,
  paymentMethodsRootSaga,
  guarantorsInformationRootSaga,
  scheduleRootSaga,
  reqAssignProvider,
  removeAssignedProvider,
  appointmentsWatcher,
  reqRelationshipPriority,
  accountVaults,
  accountVaultsForms,
  submitPaymentProgram,
  paperworkRootSaga,
  manageInsurancesRootSaga,
  appointmentsRootSaga,
];

export default function*(...args) {
  for (const watcher of watchers) {
    yield fork(watcher, ...args);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas.js